import FormDynamicMainInput from "@/components/formDynamic/components/nonPrimitiveType/formDynamicMainInput";
import NoData from "@/components/helpers/noData";
import useTrans from "@/hooks/useTrans";
import {
  postDynamicFormRefactor,
  uploadAnyFile,
} from "@/services/formDynamicApis";
import variables from "@/styles/variables.module.scss";
import dynamicFormStyle from "@/components/formDynamic/styles/dynamic-form.module.scss"
import {
  Button,
  Center,
  Container,
  Divider,
  Grid,
  Group,
  Image,
  Loader,
  Stack,
  Text,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { openContextModal } from "@mantine/modals";
import convert from "color-convert";
import CryptoJS from "crypto-js";
import { useSearchParams } from "next/navigation";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import {
  LocalStorageKey,
  newTenants,
  showFailureNotification,
} from "../../services/constants";
import {
  mapFormTemplateFieldRefactor,
  mapSectionToFormTemplateFields,
  setupDynamicForm,
} from "./services/services";
import { isNil } from "lodash";

export default function FormDynamic2(props) {
  const trans = useTrans();
  const [formTemplate, setFormTemplate] = useState(null);
  const [basicTalentInfo, setBasicTalentInfo] = useState(null);
  const [advancedTalentInfo, setAdvancedTalentInfo] = useState(null);
  const [hasCustomError, setHasCustomError] = useState(false);
  const [validateForm, setValidateForm] = useState({});
  const [formDynamicFieldArray, setFormDynamicFieldArray] = useState([]);
  const [finalFormConfig, setFinalFormConfig] = useState(null);
  const [fileToUploadArray, setFileToUploadArray] = useState([]);
  const [doneUploading, setDoneUploading] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(true);
  const [disabledInput, setDisabledInput] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const [requireUpdateInfo, setRequireUpdateInfo] = useState(true);
  const [currentTenant, setCurrentTenant] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const searchParams = useSearchParams();
  const dataOcr = searchParams.get("dataOcr");
  const router = useRouter();
  const { locale } = useRouter();

  const convertColor = convert.hex.rgb(props.primaryColor);
  const backgroundColor = `rgba(${convertColor[0]}, ${convertColor[1]}, ${convertColor[2]},0.1)`;

  const formDynamic = useForm({
    validate: validateForm,
  });

  const ekycData = (dataOcr) => {
    const wordArray = CryptoJS.enc.Base64.parse(dataOcr);

    const decodedString = CryptoJS.enc.Utf8.stringify(wordArray);

    const jsonObject = JSON.parse(decodedString);

    console.log("Chuỗi đã giải mã:", jsonObject);

    return jsonObject;
  };

  const tenant = localStorage.getItem(LocalStorageKey.TENANT);

  useEffect(() => {
    if (props.getDefaultValueApi) {
      props
        .getDefaultValueApi(props.hostNameUrl, router.query.child)
        .then((resTemplate) => {
          if (resTemplate.isError) {
            showFailureNotification(resTemplate.message, resTemplate.errorCode);
            setIsFormLoading(false);
          } else {
            const defaultValueInfo = resTemplate.data;
            const basicTalentInfoData = defaultValueInfo.application
              ? defaultValueInfo.application
              : defaultValueInfo;

            const advancedTalentInfoData = defaultValueInfo.advancedInfo
              ? defaultValueInfo.advancedInfo
              : null;
            console.log({ basicTalentInfoData, advancedTalentInfoData });
            setBasicTalentInfo(basicTalentInfoData);
            setAdvancedTalentInfo(advancedTalentInfoData);
          }
          if (props.onLoadData) {
            props.onLoadData(resTemplate?.data);
          }
        });
    }
    return () => {
      setBasicTalentInfo(undefined);
      setAdvancedTalentInfo(null);
    };
  }, []);
  useEffect(() => {
    console.log("uyntq", formDynamic.values);
    if (
      (dataOcr ||
        ((formDynamic.values?.["identity-fc"]?.["identity"]?.["issuedBy"] ||
          !props?.options?.isBlockedEkyc) &&
          ((formDynamic.values?.["policy-fc"]?.["policyAgreement"] == true &&
            formDynamic.values?.["policy-fc"]?.["commitment"] == true) ||
            (formDynamic.values?.["policy"]?.["policyAgreement"] == true &&
              formDynamic.values?.["policy"]?.["commitment"] == true)))) &&
      tenant.toLowerCase().includes("shlv")
    ) {
      setDisabledInput(false);
    } else if (tenant?.toLowerCase().includes("shlv")) {
      setDisabledInput(true);
    }
  }, [tenant, dataOcr, props.options, formDynamic.values]);
  useEffect(() => {
    if (
      (basicTalentInfo && router.query.id === "collect-form") ||
      props.recruitmentPlanId ||
      router.query.id === "apply-private"
    ) {
      const applicationCode = router.query.child;
      const recruitmentPlanId = props.recruitmentPlanId
        ? props.recruitmentPlanId
        : (basicTalentInfo?.recruitmentPlan?._id ??
          basicTalentInfo?.recruitmentPlan);

      if (props.getFormTemplateApi) {
        props
          .getFormTemplateApi(
            props.hostNameUrl,
            recruitmentPlanId,
            applicationCode,
            props.isCampaign,
          )
          .then((resTemplate) => {
            if (resTemplate.isError) {
              showFailureNotification(
                resTemplate.message,
                resTemplate.errorCode,
              );
              setIsFormLoading(false);
            } else {
              setFormTemplate(resTemplate.data);
              setIsFormLoading(false);
            }
          });
      }
      // setFormTemplate(formTemplateTest)
      // setIsFormLoading(false);
    }
  }, [basicTalentInfo, router.query.id]);

  useEffect(() => {
    if (formTemplate && (!props.useDefaultValue || basicTalentInfo)) {
      const formConfig = {
        initialValues: {
          basics: {},
          ids: {},
        },
        validate: {},
      };

      const tenant = localStorage.getItem(LocalStorageKey.TENANT);
      let returnSetup = undefined;
      let formTemplateFields = [];
      const root = document.documentElement;
      if (tenant) {
        setCurrentTenant(tenant);
        root.style.setProperty(
          "--dynamicFormLabelSize",
          tenant === "vietbank" ? "14px" : "12px",
        );
      } else {
        root.style.setProperty("--dynamicFormLabelSize", "12px");
      }
      let queryId = router.query.id;
      if (queryId === "home") {
        queryId = "recruitments";
      }
      if (!tenant || !newTenants.includes(tenant)) {
        returnSetup = setupDynamicForm(formTemplate.fields, [], queryId);
        formTemplateFields = formTemplate.fields;
      } else {
        if (queryId === "collect-form" || queryId === "recruitments") {
          const mappedFormTemplateFields = mapSectionToFormTemplateFields(
            structuredClone(formTemplate),
          );
          formTemplateFields.push(...(mappedFormTemplateFields || []));

          let sectionStatusArray = [];
          if (basicTalentInfo) {
            basicTalentInfo.extraInfos?.forEach((e) => {
              if (e.sectionCode) {
                sectionStatusArray.push({
                  sectionCode: e.sectionCode,
                  sectionStatus: e.status,
                });
              }
            });
          }

          returnSetup = setupDynamicForm(
            formTemplateFields,
            sectionStatusArray,
            queryId,
          );
        } else if (queryId === "apply-private") {
          const mappedFormTemplateFields = structuredClone(
            formTemplate.fields || [],
          ).map(mapFormTemplateFieldRefactor);
          formTemplateFields.push(...(mappedFormTemplateFields || []));
          returnSetup = setupDynamicForm(formTemplateFields, [], queryId);
        }
      }
      if (!returnSetup) {
        showFailureNotification("Lỗi khi setup đơn", "DF-3");
        setIsFormLoading(false);
        return;
      }

      formConfig.initialValues = returnSetup.initialValueObject;
      formConfig.validate = returnSetup.validateObject;

      if (basicTalentInfo && router.query.id === "collect-form") {
        formConfig.initialValues["recruitmentPlan"] =
          basicTalentInfo.recruitmentPlan;
      }

      if (props.recruitmentPlanId) {
        formConfig.initialValues["recruitmentPlan"] = props.recruitmentPlanId;
      }

      if (props.useDefaultValue) {
        if (!newTenants.includes(tenant)) {
          const initialValueFromApi = advancedTalentInfo
            ? advancedTalentInfo
            : {};
          if (
            basicTalentInfo &&
            basicTalentInfo.talent &&
            basicTalentInfo.talent.basics
          ) {
            initialValueFromApi.basics = { ...basicTalentInfo.talent.basics };
          }
          Object.keys(formConfig.initialValues).forEach((key) => {
            if (initialValueFromApi[key] !== undefined)
              formConfig.initialValues[key] = initialValueFromApi[key];
          });
        } else {
          const isFc = formTemplate.some((e) => e?.sectionCode?.includes("fc"));
          if (basicTalentInfo.talent?.basics) {
            const key = isFc ? "basics-fc" : "basics";
            if (!formConfig.initialValues[key]) {
              formConfig.initialValues[key] = {};
            }
            formConfig.initialValues[key] = Object.assign(
              formConfig.initialValues[key],
              basicTalentInfo.talent?.basics,
            );
            formConfig.initialValues[key]["placeOfBirth"] =
              basicTalentInfo.talent?.meta?.placeOfBirth ||
              formConfig.initialValues[key]["placeOfBirth"];

            if (dataOcr && tenant.toLowerCase().includes("shlv")) {
              const ekycDataExp = ekycData(dataOcr);
              formConfig.initialValues[key]["name"] = ekycDataExp.fullName;
              formConfig.initialValues[key]["dob"] = parseDateString(
                ekycDataExp.dateOfBirth,
              );
              formConfig.initialValues[key]["gender"] = ekycDataExp.gender;
            }
            if (tenant.toLowerCase().includes("shb")) {
              formConfig.initialValues["basics"]["cccd"] =
                basicTalentInfo.talent?.ids.find((e) => e?.type === "cccd")?.id;
            }
            if (tenant.toLowerCase().includes("tanlong")) {
              formConfig.initialValues["basics"]["location"] =
                basicTalentInfo.talent?.basics?.location?.address;
            }
            if (tenant.toLowerCase().includes("dxg")) {
              formConfig.initialValues["basics"]["companyInfo"] = {
                hasWorkedInCompany: basicTalentInfo.talent?.meta
                  ?.workedAtCompany
                  ? true
                  : false,
                workInCompany: {
                  chooseCompany: basicTalentInfo.talent?.meta?.workedAtCompany,
                },
              };

              formConfig.initialValues["identity"]["identity"]["info"] =
                basicTalentInfo.talent?.ids?.find((s) => s.type === "cccd")?.id;
              formConfig.initialValues["identity"]["identity"]["date"] =
                basicTalentInfo.talent?.ids?.find(
                  (s) => s.type === "issueDate",
                )?.id;
              formConfig.initialValues["identity"]["identity"]["issuedBy"] =
                basicTalentInfo.talent?.ids?.find(
                  (s) => s.type === "issueBy",
                )?.id;
            }
            if (tenant.toLowerCase().includes("svfc")) {
              formConfig.initialValues[key]["identity"] = {
                info: basicTalentInfo.talent?.meta?.identity?.id,
                issuedBy: basicTalentInfo.talent?.meta?.identity?.issuedBy,
                date: basicTalentInfo.talent?.meta?.identity?.date,
              };

              const oldCccd = basicTalentInfo.talent?.ids?.find(
                (s) => s.type === "oldCccd",
              );

              const oldIssueBy = basicTalentInfo.talent?.ids?.find(
                (s) => s.type === "oldIssueBy",
              );

              const oldIssueDate = basicTalentInfo.talent?.ids?.find(
                (s) => s.type === "oldIssueDate",
              );

              formConfig.initialValues[key]["oldIdentity"] = {
                info: oldCccd?.id,
                issuedBy: oldIssueBy?.id,
                date: oldIssueDate?.id,
              };
              // formConfig.initialValues[key]["emergencyContactLst"] = [];
            }
          }
          if (basicTalentInfo.talent?.meta?.identity) {
            const identity = basicTalentInfo.talent?.meta?.identity;
            const key = isFc ? "identity-fc" : "identity";
            if (!formConfig.initialValues[key]) {
              formConfig.initialValues[key] = { identity: {} };
            }

            if (!formConfig.initialValues[key]["identity"]) {
              formConfig.initialValues[key]["identity"] = {};
            }
          }

          //cmt
          if (dataOcr && tenant.toLowerCase().includes("shlv")) {
            const key = isFc ? "identity-fc" : "identity";

            const jsonObject = ekycData(dataOcr);

            console.log({ jsonObject });

            formConfig.initialValues[key]["identity"] = Object.assign(
              formConfig.initialValues[key]["identity"],
              {
                info: jsonObject.idNumber,
                date: parseDateString(jsonObject.issuedDate),
                frontFile: jsonObject.pathImgFront,
                backFile: jsonObject.pathImgBack,
                issuedBy: jsonObject.issuedPlace,
                expiredDate: parseDateString(jsonObject.expiredDate),
              },
            );
            console.log(
              "jsonObject",
              jsonObject,
              formConfig.initialValues[key]["identity"],
            );
          }

          if (dataOcr && tenant.toLowerCase().includes("shlv")) {
            const key = isFc ? "location-fc" : "location";

            const jsonObject = ekycData(dataOcr);

            formConfig.initialValues[key]["residenceAddress"] = Object.assign(
              formConfig.initialValues[key]["residenceAddress"],
              {
                province: jsonObject.addressDetails.province,
                district: jsonObject.addressDetails.district,
                ward: jsonObject.addressDetails.ward,
                street: jsonObject.addressDetails.street,
              },
            );

            formConfig.initialValues[key]["contactAddress"] = Object.assign(
              formConfig.initialValues[key]["contactAddress"],
              {
                province: jsonObject.addressDetails.province,
                district: jsonObject.addressDetails.district,
                ward: jsonObject.addressDetails.ward,
                street: jsonObject.addressDetails.street,
              },
            );
          }

          basicTalentInfo.extraInfos?.forEach((extraInfo) => {
            if (extraInfo.sectionCode) {
              formConfig.initialValues[extraInfo.sectionCode] = extraInfo.data;

              const index = formTemplateFields.findIndex(
                (e) => e.name === extraInfo.sectionCode,
              );
              if (index >= 0) {
                if (extraInfo.note) {
                  formTemplateFields[index].sectionNote = extraInfo.note;
                }
                if (extraInfo.status) {
                  formTemplateFields[index].sectionStatus = extraInfo.status;
                }
              }
            }
          });
        }
        // setDisabledInput(
        //   basicTalentInfo &&
        //   basicTalentInfo.requireUpdateInfo !== undefined &&
        //   !basicTalentInfo.requireUpdateInfo
        // );
        setRequireUpdateInfo(
          basicTalentInfo &&
          basicTalentInfo.requireUpdateInfo !== undefined &&
          basicTalentInfo.requireUpdateInfo,
        );
      }
      if (formConfig.initialValues["policy-fc"] === undefined) {
        formConfig.initialValues["policy-fc"] = {};
      }
      formConfig.initialValues["policy-fc"]["policyAgreement"] = false;
      formConfig.initialValues["policy-fc"]["commitment"] = false;
      if (formConfig.initialValues["policy"] === undefined) {
        formConfig.initialValues["policy"] = {};
      }
      formConfig.initialValues["policy"]["policyAgreement"] = false;
      formDynamic.setValues(formConfig.initialValues);
      setValidateForm(formConfig.validate);
      setFormDynamicFieldArray(formTemplateFields);
      setFinalFormConfig(formConfig);
      setIsFormLoading(false);
    }
  }, [formTemplate, basicTalentInfo, advancedTalentInfo, dataOcr]);

  useEffect(() => {
    if (doneUploading) {
      const handleFormSuccess = (
        talentApplyResultCode = null,
        successMessage = "",
      ) => {
        let handleClose = () => { };

        if (["collect-form", "apply-private"].includes(router.query.id)) {
          handleClose = () => {
            setDisabledInput(true);
          };
        } else if (props.closeModal) {
          handleClose = props.closeModal;
        }

        if (!props.hideApplicationCode) {
          let code = talentApplyResultCode;
          if (!isNil(code) && Array.isArray(code) && code.length > 0) {
            code = (
              <>
                {code.map((code) => (
                  <div key={code}>{code}</div>
                ))}
              </>
            );
          }
          openContextModal({
            modal: "success",
            centered: true,
            innerProps: {
              text:
                props.collectFormHeader?.successApplyMessage?.[locale] ?? trans.applyNow.success,
              content: successMessage,
              color: variables.primaryColor,
              code,
            },
            onClose: handleClose,
          });
        } else {
          openContextModal({
            modal: "success",
            centered: true,
            innerProps: {
              text:
                props.messageSuccessNoCode ?? trans.applyNow.successBodyNoCode,
              color: variables.primaryColor,
            },
            onClose: handleClose,
          });
        }
      };

      let formType = "apply";
      switch (router.query.id) {
        case "collect-form":
          formType = "extra-info";
          break;

        case "apply-private":
          formType = "private";
          break;
      }

      const originalValues = structuredClone(formDynamic.values);

      const sendData = async () =>
        await postDynamicFormRefactor(
          formDynamic.values,
          props.hostNameUrl,
          formType,
          props.isCampaign,
          basicTalentInfo?._id || basicTalentInfo?.applicationId,
          basicTalentInfo?.talent?.meta,
          formDynamicFieldArray,
          router.query.external_link,
        );
      sendData().then((responsePost) => {
        if (responsePost.isError) {
          formDynamic.setValues(originalValues);
          showFailureNotification(responsePost.message, responsePost.errorCode);
        } else {
          handleFormSuccess(
            props.useDefaultValue ? null : responsePost.data,
            responsePost.message,
          );
          setIsFormSubmitted(true);
        }

        setFileToUploadArray([]);
        setDoneUploading(false);
        setIsFormLoading(false);
      });
    }
  }, [doneUploading]);

  const handleClick = (e) => {
    e.preventDefault();
    console.log("values", formDynamic.values);
    console.log("errors", formDynamic.errors);

    const validation = formDynamic.validate();
    if (!validation.hasErrors && !hasCustomError) {
      setIsFormLoading(true);
      const fileUploadPromises = fileToUploadArray.map((fileToUpload) => {
        const inputTemplate = fileToUpload.inputTemplate;
        const uploadFile = async (fileSingle) =>
          await uploadAnyFile(fileSingle, props.hostNameUrl);
        const returnObject = {
          value: null,
          key: fileToUpload.inputName,
        };

        if (Array.isArray(fileToUpload.file)) {
          const fileArray = fileToUpload.file;
          const fileArrayPromise = fileArray.map((fileSingle) => {
            return uploadFile(fileSingle).then((res) => {
              if (res && res.url) {
                if (inputTemplate && inputTemplate.metadata?.urlOnly) {
                  return res.url;
                }
                return res;
              }
              return null;
            });
          });
          return Promise.all(fileArrayPromise).then((resData) => {
            returnObject.value = resData;
            return returnObject;
          });
        } else {
          const fileSingle = fileToUpload.file;
          return uploadFile(fileSingle).then((res) => {
            if (res && res.url) {
              if (inputTemplate && inputTemplate.metadata?.urlOnly) {
                returnObject.value = res.url;
              } else {
                returnObject.value = res;
              }
            }
            return returnObject;
          });
        }
      });

      if (fileUploadPromises.length === 0) {
        setDoneUploading(true);
      } else {
        Promise.all(fileUploadPromises).then((fileUploadResArray) => {
          let hasUploadError = false;

          fileUploadResArray.forEach((fileUploadRes) => {
            if (!fileUploadRes) return;

            const value = fileUploadRes.value;
            const failed = Array.isArray(value)
              ? value.some((v) => v === null)
              : value === null;

            if (failed) {
              hasUploadError = true;
              formDynamic.setFieldError(
                fileUploadRes.key,
                "Tải file thất bại. Vui lòng thử lại.",
              );
            } else {
              formDynamic.setFieldValue(fileUploadRes.key, value);
            }
          });

          if (hasUploadError) {
            setIsFormLoading(false);
            showFailureNotification(
              "Tải file thất bại. Vui lòng kiểm tra lại các trường upload.",
              "DF-FILE-1",
            );
            setTimeout(() => {
              const firstInvalid = document.querySelector(
                '[data-invalid="true"], [aria-invalid="true"], [data-form-error="true"]',
              );
              if (firstInvalid) {
                firstInvalid.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
                firstInvalid.focus?.();
              }
            }, 0);
            return;
          }

          setFileToUploadArray([]);
          setDoneUploading(true);
        });
      }
    } else {
      showFailureNotification(
        "Thông tin điền vào đơn chưa hợp lệ. Vui lòng kiểm tra lại",
        "DF-2",
      );
      setTimeout(() => {
        const firstInvalid = document.querySelector('[data-invalid="true"], [aria-invalid="true"], [data-form-error="true"]');
        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
          firstInvalid.focus?.();
        }
      }, 0);
    }
  };

  const configuredContentWidth = props.contentWidth || props.windowDimension.width;
  const currentWidth = Math.min(
    props.windowDimension.width || configuredContentWidth,
    configuredContentWidth,
  );
  let inputRowSpacing = 24;
  const fontDivider = currentWidth >= 800 ? 1 : 1.5;
  let numInputPerRow = 3;
  let padding = 44;

  if (currentWidth <= 1000) {
    numInputPerRow = 2;
    inputRowSpacing = 22;
    padding = 22;
  }
  if (currentWidth <= 800) {
    numInputPerRow = 1;
    inputRowSpacing = 20;
    padding = 15;
  }

  // const disabledInput = basicTalentInfo && basicTalentInfo.requireUpdateInfo !== undefined && !(basicTalentInfo.requireUpdateInfo);

  const formDynamicFieldPriorityFields = formDynamicFieldArray.filter(
    (e) => e.priority !== undefined,
  );
  const formDynamicFieldNonPriorityFields = formDynamicFieldArray.filter(
    (e) => e.priority === undefined,
  );
  const formDynamicFieldArraySorted = [
    ...formDynamicFieldPriorityFields,
    ...formDynamicFieldNonPriorityFields,
  ];

  const inputSectionJSXs = formDynamicFieldArraySorted.map(
    (fieldTemplateMain, index) => {
      return (
        <FormDynamicMainInput
          key={index}
          hostNameUrl={props.hostNameUrl}
          formDynamic={formDynamic}
          finalFormConfig={finalFormConfig}
          numInputPerRow={numInputPerRow}
          fieldTemplateMain={fieldTemplateMain}
          currentWidth={currentWidth}
          backgroundColor={backgroundColor}
          primaryColor={props.primaryColor}
          inputRowSpacing={inputRowSpacing}
          disabledInput={disabledInput}
          requireUpdateInfo={requireUpdateInfo}
          setDisabledInput={setDisabledInput}
          disabledButton={disabledButton}
          hideButton={!props?.options?.isBlockedEkyc}
          setDisabledButton={setDisabledButton}
          setHasCustomError={setHasCustomError}
          currentNameArray={
            fieldTemplateMain.name ? [fieldTemplateMain.name] : []
          }
          setFileToUploadArray={setFileToUploadArray}
          fileToUploadArray={fileToUploadArray}
          setDisabledSubmit={setDisabledSubmit}
          sectionStatus={fieldTemplateMain.sectionStatus}
          sectionNote={fieldTemplateMain.sectionNote}
          isFormSubmitted={isFormSubmitted}
          talentCode={props.talentCode}
        />
      );
    },
  );

  let mainContent = (
    <Stack spacing={padding} pb={padding} w={'100%'}>
      {props.useDefaultValue ? (
        <Stack
          spacing={"md"}
          style={{
            backgroundColor: backgroundColor,
            padding: 10,
          }}
        >
          {props.logo && (
            <>
              <Center>
                <Image src={props.logo} alt="logo" style={{ width: 188 }} />
              </Center>
              <Container w={175}>
                <Divider style={{ borderBlockColor: "#1890FF" }} />
              </Container>
            </>
          )}
          <Text
            ta={"center"}
            fw={600}
            fz={32 / fontDivider}
            c={variables.primaryColor}
          >
            {formTemplate
              ? props.collectFormHeader?.title || "Đơn bổ sung thông tin"
              : "Đang tải..."}
          </Text>
          <Text ta={"center"} fz={18 / fontDivider} c={"#232323"}>
            {props.collectFormHeader?.description ??
              "Cảm ơn bạn đã ứng tuyển tại công ty. Bạn vui lòng hoàn thành đơn bổ sung thông tin dưới đây trước thời hạn quy định"}
          </Text>
        </Stack>
      ) : (
        <></>
      )}
      {!requireUpdateInfo && newTenants.includes(currentTenant) && (
        <Text
          ta={"center"}
          fw={600}
          fz={32 / fontDivider}
          mb={-padding}
          c={"red"}
        >
          Thông tin đang được kiểm tra.
        </Text>
      )}
      {requireUpdateInfo &&
        formDynamic.values?.["identity-fc"]?.["identity"]?.["issuedBy"] &&
        tenant === "shlv" && (
          <Text
            ta={"center"}
            fw={600}
            fz={24 / fontDivider}
            mb={-padding}
            c={"green"}
          >
            Thông tin đã được eKYC
          </Text>
        )}
      <Center>
        <Grid columns={12} m={0} px={padding} gutter={inputRowSpacing} maw={currentWidth}>
          {inputSectionJSXs}
        </Grid>
      </Center>
      {isFormLoading && (
        <Center>
          <Stack
            justify={"center"}
            align={"center"}
            style={{ height: "100%" }}
            spacing={20}
          >
            <Loader color={props.primaryColor} />
            <Text fw={700} c={props.primaryColor}>
              Đang tải...
            </Text>
          </Stack>
        </Center>
      )}

      {formTemplate &&
        !disabledInput &&
        requireUpdateInfo &&
        !isFormLoading &&
        !tenant?.toLowerCase().includes("shlv") ? (
        <Center>
          <Group position={"center"} w={currentWidth}>
            <Button
              type={"submit"}
              className={`${dynamicFormStyle.formDynamicSubmitButton} formDynamicSubmitButton`}
              disabled={disabledSubmit}
              onClick={(e) => handleClick(e)}
            >
              {props.submitButtonLabel?.[locale] ?? trans.apply}
            </Button>
          </Group>
        </Center>
      ) : (
        <></>
      )}
      {formTemplate &&
        !disabledInput &&
        requireUpdateInfo &&
        !isFormLoading &&
        tenant?.toLowerCase().includes("shlv") &&
        (dataOcr ||
          ((formDynamic.values?.["identity-fc"]?.["identity"]?.["issuedBy"] ||
            !props?.options?.isBlockedEkyc) &&
            formDynamic.values?.["policy-fc"]?.["policyAgreement"] == true &&
            formDynamic.values?.["policy-fc"]?.["commitment"] == true)) ? (
        <Group position={"center"}>
          <Button
            type={"submit"}
            bg={variables.primaryColor}
            disabled={disabledSubmit}
            style={{ width: 200, borderRadius: 100 }}
            onClick={(e) => handleClick(e)}
          >
            {props.submitButtonLabel[locale] ?? trans.apply}
          </Button>
        </Group>
      ) : (
        <></>
      )}
    </Stack>
  );

  function parseDateString(dateString) {
    const parts = dateString.split("/");
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    return new Date(year, month, day);
  }

  const badContent = (
    <Center>
      <Stack
        justify={"center"}
        align={"center"}
        style={{ height: "100vh" }}
        spacing={20}
      >
        <NoData
          hasImage={true}
          hasText={true}
          noDataText={`Không Có Ứng Viên Với Mã ${props.talentCode}`}
        />
      </Stack>
    </Center>
  );

  // const loadingContent = (
  //     <Center>
  //         <Stack justify={"center"} align={"center"} style={{height: "100vh"}} spacing={20}>
  //             <Loader color={props.primaryColor}/>
  //             <Text fw={700} c={props.primaryColor}>Đang tải...</Text>
  //         </Stack>
  //     </Center>
  // )

  if (props.useDefaultValue && !basicTalentInfo && !isFormLoading) {
    return badContent;
  }
  return mainContent;
}
